var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('div',{staticClass:"border border-red-600 theme-bg px-4"},[_c('AboutMe')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }